export const visit = (vm, at) => {
at({ "it": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Problemi con il video?", "playButton": "Tasto play" } } });
};